import _ from "lodash";
import React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  AppBar,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  Toolbar,
  Typography
} from "@material-ui/core";
import { API_URL } from "../../../constants/api";
import { apiRequest } from "../../../utils/api_service";
import {
  GetUserConfiguration,
  IsSectionVisible,
  IsTenant,
  IsTenantAdmin,
  PaperComponent,
  getColorClass,
  removeDuplicates,
  sortArray
} from "../../../utils/helper";
import { getPhoneNumberWithMask } from "../../../utils/generic";
import { Tooltip } from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import AddUpdateTenantContact from "../contact/addUpdateContact";
import { SECTIONS } from "../../../constants/appConstants";
import { isMobile, isTablet } from "react-device-detect";
import { ExpandMore, InfoOutlined } from "@material-ui/icons";
import TenantViewContactTableMobileView from "./tenantViewContactTableMobileView";
import { convertAPIDateInStdFormat, getDiffInDays } from "../../../utils/date";
import { IoMdCloseCircleOutline } from "react-icons/io";

class TenantViewContact extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tenantContactsList: [],
      isAddUpdateDialogOpen: false,
      tenantContactId: 0,
      tenantId: 0,
      masterData: props.masterData,
      isContactSaved: false,
      canAddContact: props.canAddContact,
      toolTipData: props.toolTipData
    };
  }

  componentDidMount() {
    this.getTenantContactsList();
  }

  /**
   * refresh tenant contact list on new props
   */
  componentWillReceiveProps(newProps) {
    const { isContactSaved } = this.state;
    if (
      newProps.isContactSaved != isContactSaved &&
      newProps.isContactSaved == true
    ) {
      this.setState({ isContactSaved: true });
      this.getTenantContactsList();
    }
  }

  /**
   * get the tenant contact list
   */
  getTenantContactsList = () => {
    const params = {
      tenantId: 0
    };
    apiRequest({
      url: API_URL.tenantContact.GetTenantContacts,
      params
    }).then(({ data: List }) => {
      this.setState({
        tenantContactsList: List,
        isContactSaved: false
      });
    });
  };

  /**
   * update pagination count
   * @param {*} pageNo
   * @param {*} rowsPerPagination
   */
  updateRowCount = (pageNo, rowsPerPagination) => {
    this.setState({ pageNo, rowsPerPagination });
  };

  /**
   * open pop up on click on add/edit button
   * @param {*} isOpen
   * @param {*} TenantUserId
   * @param {*} TenantId
   */
  openAddUpdateDialogOpen = (isOpen = true, TenantUserId = 0, TenantId = 0) => {
    this.setState({
      isAddUpdateDialogOpen: isOpen,
      tenantContactId: TenantUserId,
      tenantId: TenantId
    });
  };

  /**
   * refresh contact list
   * @param {*} isContactSaved
   */
  refreshContacts = (isContactSaved = false) => {
    if (isContactSaved) {
      this.getTenantContactsList();
    }
    this.openAddUpdateDialogOpen(false);
  };

  /**
   * set request permission value when click on count
   * @param {*} viewAll
   * @param {*} dataCenters
   * @param {*} title
   */
  handleViewAllRequestPermissions = (
    viewAll = false,
    dataCenters,
    title = ""
  ) => {
    this.setState({
      viewAllRequestPermission: viewAll,
      selectedRequestPermission: dataCenters,
      title
    });
  };

  render() {
    const {
      tenantContactsList,
      isAddUpdateDialogOpen,
      tenantContactId,
      tenantId,
      masterData,
      canAddContact,
      toolTipData,
      rowsPerPagination,
      pageNo,
      viewAllRequestPermission,
      title,
      selectedRequestPermission
    } = this.state;

    const filteredTenantContactsList = IsTenantAdmin()
      ? tenantContactsList
      : tenantContactsList?.filter(f => !f.IsExpired);

    const tenantContactsListing = IsSectionVisible(
      SECTIONS.TENANT,
      SECTIONS.CONTACT_LIST
    );

    const addContactVisible = IsSectionVisible(
      SECTIONS.TENANT,
      SECTIONS.ADD_UPDATE_CONTACT
    );

    const canEditContact = addContactVisible && canAddContact;
    const loggedInEmail = GetUserConfiguration()?.email;

    /**
     * Getting Grouped data For Contacts
     */
    const groupDataForContacts =
      (
        _.chain(
          rowsPerPagination > 0
            ? filteredTenantContactsList.slice(
                pageNo * rowsPerPagination,
                pageNo * rowsPerPagination + rowsPerPagination
              ) || []
            : filteredTenantContactsList
        ) || []
      )
        .groupBy(x => x.PropertyName)
        .map(function(v, i) {
          return {
            key: i,
            dataList: v
          };
        })
        .value() || [];

    return (
      <>
        <div>
          {isAddUpdateDialogOpen && masterData && (
            <AddUpdateTenantContact
              isOpen={isAddUpdateDialogOpen}
              onClose={this.openAddUpdateDialogOpen}
              onSave={this.refreshContacts}
              tenantContactId={tenantContactId}
              tenantId={tenantId}
              masterData={masterData}
              toolTipData={toolTipData}
            />
          )}
        </div>
        <div className={"tenant-view-contact-table-div"}>
          {tenantContactsListing ? (
            IsTenant() === true && (isMobile || isTablet) ? (
              <>
                {filteredTenantContactsList &&
                filteredTenantContactsList.length > 0 ? (
                  groupDataForContacts.map(function(v, i) {

                    return (
                      <Accordion>
                        <AccordionSummary
                          expandIcon={<ExpandMore />}
                          aria-controls={"Column-content" + i}
                          id={"panel-header" + i}
                        >
                          <Typography>
                            {v.key}
                            {" (Users)"}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <TenantViewContactTableMobileView data={v.dataList} />
                        </AccordionDetails>
                      </Accordion>
                    );
                  })
                ) : (
                  <></>
                )}
              </>
            ) : (
              <table
                className={"tenant-view-contact-table"}
                style={{ fontWeight: "200 !important" }}
              >
                <thead>
                  <tr
                    className={"header-blue"}
                    style={{ borderTop: "3px solid #FFFFFF" }}
                  >
                    <th colSpan={8} align={"center"}>
                      {"Tenant Contacts\r"}
                    </th>
                  </tr>
                  <tr
                    className={"header-blue"}
                    style={{ borderTop: "3px solid #FFFFFF" }}
                  >
                    <th className={"w-15"} align={"left"}>
                      {"Data Center\r"}
                    </th>
                    <th className={"w-20"} align={"left"}>
                      {"Contact Name\r"}
                    </th>
                    <th className={"w-10"} align={"left"}>
                      {"Work Phone\r"}
                    </th>
                    <th className={"w-10"} align={"left"}>
                      {"Cell Phone\r"}
                    </th>
                    <th className={"w-20"} align={"left"}>
                      {"Email\r"}
                    </th>
                    <th className={"w-10"} align={"left"}>
                      {"Expire Date\r"}
                      <Tooltip
                        title={
                          toolTipData?.find(
                            b => b.UiColumnName == "Expire Date"
                          )?.Tooltip || ""
                        }
                      >
                        <IconButton
                          style={{ pointerEvents: "auto" }}
                          size={"small"}
                          className={"tooltip-iconSize"}
                        >
                          <InfoOutlined
                            style={{ fill: "white" }}
                            fontSize={"inherit"}
                          />
                        </IconButton>
                      </Tooltip>
                    </th>
                    <th className={"w-30"} align={"left"}>
                      {"Request Permissions\r"}
                    </th>
                    <th className={"w-5"} style={{ textAlign: "center" }}>
                      {"Action\r"}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {filteredTenantContactsList &&
                  filteredTenantContactsList.length > 0 ? (
                    (
                      (rowsPerPagination > 0
                        ? filteredTenantContactsList.slice(
                            pageNo * rowsPerPagination,
                            pageNo * rowsPerPagination + rowsPerPagination
                          )
                        : filteredTenantContactsList) || []
                    ).map((item, index) => (
                      <tr key={"contacts" + index}>
                        <td>{item.PropertyName}</td>
                        <td>{item.UserName}</td>
                        <td>
                          {item.OfficePhone == null || item.OfficePhone == ""
                            ? "-"
                            : getPhoneNumberWithMask(item.OfficePhone)}
                        </td>
                        <td>
                          {item.CellPhone == null || item.CellPhone == ""
                            ? "-"
                            : getPhoneNumberWithMask(item.CellPhone)}
                        </td>
                        <td>{item.Email}</td>
                        <td>
                          <span
                            className={`colorText ${getColorClass(
                              getDiffInDays(
                                new Date(),
                                item.ExpireDate
                                  ? new Date(item.ExpireDate.split("T")[0])
                                  : ""
                              )
                            )}`}
                          >
                            {item.ExpireDate
                              ? convertAPIDateInStdFormat(
                                  item.ExpireDate.split("T")[0]
                                )
                              : "-"}
                          </span>
                        </td>
                        <td style={{ textAlign: "center" }}>
                          {item.RequestTypes == null ? (
                            "-"
                          ) : (
                            <>
                              <span
                                className={"underline"}
                                style={{
                                  cursor: "pointer",
                                  fontSize: "0.7rem",
                                  textAlign: "center"
                                }}
                                onClick={() =>
                                  this.handleViewAllRequestPermissions(
                                    true,
                                    item.RequestTypes,
                                    "Request Permissions"
                                  )}
                              >
                                {
                                  removeDuplicates(item.RequestTypes.split(","))
                                    .length
                                }
                              </span>
                            </>
                          )}
                        </td>
                        <td style={{ textAlign: "center" }}>
                          {!canEditContact && loggedInEmail !== item.Email ? (
                            <Tooltip
                              title={"View Tenant Contact"}
                              onClick={() => {
                                this.setState({
                                  tenantContactId: item.TenantUserId
                                });
                                this.openAddUpdateDialogOpen(
                                  true,
                                  item.TenantUserId,
                                  item.TenantId
                                );
                              }}
                            >
                              <IconButton size={"small"}>
                                <IconButton size={"small"}>
                                  <VisibilityIcon
                                    fontSize={"inherit"}
                                    size={"small"}
                                    style={{ cursor: "pointer" }}
                                  />
                                </IconButton>
                              </IconButton>
                            </Tooltip>
                          ) : (
                            <Tooltip
                              title={
                                toolTipData?.find(b => b.UiColumnName == "Edit")
                                  ?.Tooltip
                              }
                              onClick={() => {
                                this.setState({
                                  tenantContactId: item.TenantUserId
                                });
                                this.openAddUpdateDialogOpen(
                                  true,
                                  item.TenantUserId,
                                  item.TenantId
                                );
                              }}
                            >
                              <IconButton size={"small"}>
                                <EditIcon size={"small"} />
                              </IconButton>
                            </Tooltip>
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td style={{ textAlign: "center" }} colSpan={6}>
                        {"No data available\r"}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            )
          ) : (
            <></>
          )}
        </div>
        <Dialog
          open={viewAllRequestPermission || false}
          onClose={() => this.handleViewAllRequestPermissions(false, "")}
          PaperComponent={PaperComponent}
          fullWidth
        >
          <AppBar style={{ position: "relative", backgroundColor: "#064473" }}>
            <Toolbar>
              <Typography
                variant={"h6"}
                style={{ marginLeft: "10px", flex: "1" }}
              >
                {title}
              </Typography>
              <IconButton
                title={"Close"}
                edge={"end"}
                color={"inherit"}
                onClick={() => this.handleViewAllRequestPermissions(false, "")}
                aria-label={"close"}
                className={"white-button"}
              >
                <IoMdCloseCircleOutline />
              </IconButton>
            </Toolbar>
          </AppBar>
          <DialogContent>
            {selectedRequestPermission &&
              sortArray(
                removeDuplicates(selectedRequestPermission.split(","))
              )?.map((obj, index) => (
                <Chip
                  className={"chip"}
                  key={"chip" + index + "c"}
                  label={obj}
                  style={{ margin: 1, fontSize: "0.7rem", height: "1.8rem" }}
                />
              ))}
          </DialogContent>
          <DialogActions>
            <Button
              color={"primary"}
              onClick={() => this.handleViewAllRequestPermissions(false, "")}
            >
              {"Close\r"}
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }
}
export default TenantViewContact;
